import { TAdvertInboxPayload } from "@ephatta/services"
import { useEphattaQuery } from "../../.."
import { useAdvertInboxService } from "./useAdvertInboxService"

export const useAdvertInboxs = (payload?: TAdvertInboxPayload, suspense?: boolean) => {
    const service = useAdvertInboxService()
    return useEphattaQuery(["Adverts.Inboxs", payload], () => service.getAll(payload), { refetchOnMount: true, suspense })
} 